import React from "react";
import MarketingNav from "../MarketingSite/MarketingNav";
import Logo from "../MarketingSite/Logo";
import "../MarketingSite/MarketingPage.css";

const AuthShell = ({ title, subtitle, children }) => {
  return (
    <div className="marketing-root">
      <MarketingNav showSectionLinks={false} />
      <div className="auth-wrap">
        <div className="auth-card">
          <div className="auth-logo">
            <Logo />
          </div>
          {title && <h1>{title}</h1>}
          {subtitle && <p className="auth-sub">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
